<main class="page-container" [ngClass]="{ lg: width === 'lg', sm: width === 'sm' }">
  <!--   <div class="back" [routerLink]="['../']">
  <span inlineSVG="/icons/icon-arrow-current-color.svg"></span>{{ backText || 'global.back' | transloco }}
</div> -->
  <div class="above-page">
    <div class="back" (click)="backLocation()">
      <span inlineSVG="/icons/icon-arrow-current-color.svg"></span>{{ backText || 'global.back' | transloco }}
    </div>
    <div>
      <ng-container *ngTemplateOutlet="topRightCorner"></ng-container>
    </div>
  </div>
  @if (headerText) {
    <h2>{{ headerText }}</h2>
  }
  <ng-content></ng-content>
</main>
